"use client";

import { useRouter } from "next/navigation";
import React from "react";
import Button from "@/shared/Buttons/Button";
import styles from "./styles.module.css";

const MapPromo = () => {
	const router = useRouter();
	return (
		<div
			className={styles.mapPromoBlock}
			style={{
				backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(./imgs/map.webp)`,
			}}
		>
			<h4>Поиск по карте</h4>
			<p>Ищите новостройки рядом с работой, парком или родственниками</p>
			<Button
				color={"white"}
				text={"Найти"}
				onClick={() =>
					router.push("/maps/new-buildings/?filters%5Bad_type%5D=sale")
				}
			/>
		</div>
	);
};

export default MapPromo;
